import { designTokens } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";

type Props = {
	onCancel: () => void;
	onConfirm: () => void;
};

export function ShowTenantConfirmModal({ onCancel, onConfirm }: Props) {
	return (
		<Modalv2 isOpen onClose={onCancel}>
			<ModalHeader title="設定内容の確認" />
			<ModalBody>
				<Paragraph mb={designTokens["spacing/s"]}>
					以下の設定が有効な状態で保存されます。
				</Paragraph>
				<Label weight="bold">案件依頼先に個人情報を公開する</Label>
				<Alertv2 mt={designTokens["spacing/s"]} variant="warning">
					<Paragraph>
						公開すると、案件依頼先に個人情報を含む資料が表示されます。
					</Paragraph>
				</Alertv2>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Buttonv2 onClick={onCancel} variant="secondary">
						キャンセル
					</Buttonv2>
				}
				rightArea={
					<Buttonv2 onClick={onConfirm} variant="primary">
						保存
					</Buttonv2>
				}
			/>
		</Modalv2>
	);
}
